import { useState, useCallback } from 'react';
import { testimonials } from '@/mocks/comics';

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  }, []);

  const t = testimonials[current];

  return (
    <section className="py-14 md:py-20 bg-background-50 overflow-hidden" aria-labelledby="testimonial-title">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-10">
            <span className="text-xs font-medium text-accent-600 uppercase tracking-wider">读者评价</span>
            <h2 id="testimonial-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-2">
              读者们<span className="italic font-normal text-accent-500">这样说</span>
            </h2>
          </div>

          <div className="relative bg-background-950 rounded-3xl overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-5 min-h-[380px]">
              <div className="lg:col-span-2 relative overflow-hidden">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background-950 hidden lg:block"></div>
                <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-transparent to-transparent lg:hidden"></div>
              </div>

              <div className="lg:col-span-3 flex flex-col justify-center px-6 md:px-12 py-10 lg:py-12">
                <span className="font-heading text-6xl md:text-8xl text-accent-500/30 leading-none select-none">&ldquo;</span>
                <p className="text-base md:text-lg text-background-100 leading-relaxed -mt-4">
                  {t.content}
                </p>
                <div className="mt-6">
                  <p className="font-sans text-sm font-semibold text-background-50">{t.name}</p>
                  <p className="text-xs text-background-300 mt-0.5">{t.role}</p>
                </div>

                <div className="flex items-center gap-3 mt-8">
                  <button
                    onClick={prev}
                    className="w-10 h-10 rounded-full border border-background-600 hover:border-accent-500 hover:bg-accent-500/10 text-background-300 hover:text-accent-500 flex items-center justify-center transition-colors cursor-pointer"
                    aria-label="上一条评价"
                  >
                    <i className="ri-arrow-left-line"></i>
                  </button>
                  <button
                    onClick={next}
                    className="w-10 h-10 rounded-full border border-background-600 hover:border-accent-500 hover:bg-accent-500/10 text-background-300 hover:text-accent-500 flex items-center justify-center transition-colors cursor-pointer"
                    aria-label="下一条评价"
                  >
                    <i className="ri-arrow-right-line"></i>
                  </button>
                  <div className="flex items-center gap-2 ml-4">
                    {testimonials.map((_, idx) => (
                      <button
                        key={idx}
                        onClick={() => setCurrent(idx)}
                        className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                          idx === current ? 'bg-accent-500 w-5' : 'bg-background-600'
                        }`}
                        aria-label={`第${idx + 1}条评价`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}